//  import './components/assets/css/animate.css';
 import './components/assets/css/bootstrap.css';
 import './components/assets/css/main.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import Header from './components/Header';
import Navbar from './components/Navbar';
import HomePage from './components/HomePage';
import ContactClasses from './components/ContactClasses';
import Footer from './components/Footer';
import Books from './components/Books';
import Research from './components/Research';
import Patent from './components/Patent';
import Infosys from './components/InfoSys';
import WebSys from './components/WebSys';
import Oop from './components/Oop';
import Contact from './components/Contact';
import Blog from './components/Blog';
import SingleBlog from './components/SingleBlog';
import Chapter01 from './components/chapters/chap-1';
import Chapter02 from './components/chapters/chap-2';
import Chapter03 from './components/chapters/chap-3';
import Chapter04 from './components/chapters/chap-4';
import Chapter05 from './components/chapters/chap-5';
import Chapter06 from './components/chapters/chap-6';
import Chapter07 from './components/chapters/chap-7';
import Chapter08 from './components/chapters/chap-8';
import Chapter11 from './components/chapters/chap-11';
import Chapter09 from './components/chapters/chap-9';
import Chapter20 from './components/chapters/chap-20';
import Swal from 'sweetalert2';
const useIdle = (timeout, onIdle, isLoggedIn) => {
  useEffect(() => {
    if (!isLoggedIn) return; // Do nothing if the user is not logged in

    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => onIdle(), timeout);
    };

    const handleActivity = () => resetTimer();

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('scroll', handleActivity);

    resetTimer();

    return () => {
      clearTimeout(timer);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('scroll', handleActivity);
    };
  }, [timeout, onIdle, isLoggedIn]);
};


const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('token'));
  const [isIdle, setIsIdle] = useState(false);
 // const navigate = useNavigate();
  const handleLogout = () => {
    // localStorage.removeItem("userData");
   // navigate("/");
    localStorage.clear();
    window.location.reload();
  }
  const handleIdle = () => {
    setIsIdle(true);
    Swal.fire({
      title: 'You have been idle!',
      text: 'Do you want to log out or continue?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Logout',
      cancelButtonText: 'Cancel',
      timer: 45000, // 45 seconds timer
      timerProgressBar: true,
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('User logged out'); // Replace with your logout logic
        setIsLoggedIn(false); // Simulating logout
        setIsIdle(false);
        handleLogout();
      } else if (result.dismiss === Swal.DismissReason.timer) {
        handleLogout();
        console.log('User auto-logged out due to inactivity'); // Auto logout
        setIsLoggedIn(false); // Simulating logout
        setIsIdle(false);
      } else {
        console.log('User resumed activity');
        setIsIdle(false);
      }
    });
  };

  useIdle(1000 * 60 * 5, handleIdle, isLoggedIn); // 5 minutes timeou
  return (
    <Router>
      <Header />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact-classes" element={<ContactClasses />} />
        <Route path="/books" element={<Books />} />
        <Route path="/research" element={<Research />} />
        <Route path="/patent" element={<Patent />} />
        <Route path="/infosys" element={<Infosys />} />
        <Route path="/websys" element={<WebSys />} />
        <Route path="/c++oops" element={<Oop />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/single_blog/:id" element={<SingleBlog />} />
        <Route path="/chap01" element={<Chapter01 />} />
        <Route path="/chap02" element={<Chapter02 />} />
        <Route path="/chap03" element={<Chapter03 />} />
        <Route path="/chap04" element={<Chapter04 />} />
        <Route path="/chap05" element={<Chapter05 />} />
        <Route path="/chap06" element={<Chapter06 />} />
        <Route path="/chap07" element={<Chapter07 />} />
        <Route path="/chap08" element={<Chapter08 />} />
        <Route path="/chap11" element={<Chapter11 />} />
        <Route path="/chap09" element={<Chapter09 />} />
        <Route path="/chap20" element={<Chapter20 />} />
        {/* Define other routes here */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;

